import { Box } from '@usealloy/component-library';
import styled from 'styled-components';

export const StyledTooltipWrapper = styled.div`
  position: relative;
`;

export const OnHoverOverlay = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(250, 250, 249, 0.8);
  opacity: 0;

  &:hover {
    opacity: 1;
  }
`;

export const SnippetTooltipHelperText = styled.span`
  display: block;
  color: var(--cl-text-muted);
  font-size: var(--cl-font-size-1);
  margin-top: 0;
  margin-bottom: var(--cl-space-1);
`;

export const TruncatedSnippetDescription = styled.span`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-word;
`;
